<!-- header Start-->
<section class="event header" id="home">
    <div class="header3 bg" [ngStyle]="{'background-image': 'url(assets/images/event/background-header.jpg)'}" style="min-height: 720px;">
        <div class="event-content">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 offset-xl-3 col-md-10 offset-md-1">
                        <div class="center-text">
                            <div class="text-center w-100">
                                <div class="h1-margin" [ngStyle]="{'background-image': 'url(assets/images/event/title.png)'}" style="
                                        background-position: center center;
                                        background-size: contain;
                                        background-repeat: no-repeat;
                                        width: auto;
                                        height: 100vw;
                                        margin-bottom: 30px;
                                        background-image: url(assets/images/event/title.png);">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- header end-->